
	import ViewBase from '@/View/Base';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt.kenefick@buck.co>
	 * @package View/Scene/People
	 * @project buck-impact-2024
	 */
	@Component
	export default class ViewScenePeopleRetentionHiring extends ViewBase {
		// Not implemented
	}
